import { Model } from "./model";

export class Challenge extends Model {
    id: number;
    challenge_type_id: number;
    brand_id: number;
    country_id: number;
    language_id: number;
    product_id: number;
    name: string;
    description: string;
    image: string;
    image_url: string;
    published: number;
    created: string;
    challenge_type_name: string;
    brand_name: string;
    brand_logo: string;
    brand_logo_url: string;
    country_name: string;
    language_name: string;
    language_flag: string;
    product_name: string;
    product_ref: number;
}


// WEBPACK FOOTER //
// ./src/models/challenge.model.ts